export function ArrowReplyFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <g clipPath="url(#clip0_2_2868)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M11 5.769c0-1.362-1.668-2.02-2.596-1.024l-5.816 6.231a1.5 1.5 0 000 2.047l5.816 6.232c.928.995 2.596.338 2.596-1.023V16a13.58 13.58 0 018.979 3.43c.783.696 2.021.14 2.021-.907v-.138C22 12.65 17.35 8 11.615 8H11V5.769z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2_2868">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
